import React, { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../store/auth-context";
import Sidebar from "../components/Sidebar/Sidebar";
import usePageBottom from "../hooks/usePageBottom";
import MobileNav from "../components/Sidebar/MobileNav";
import LoginModal from "../common/LoginModal/LoginModal";

const AuthLayout = () => {
  const authContext = useContext(AuthContext);
  const customElementRef = useRef(null);
  const reachedBottom = usePageBottom(
    { rootMargin: 0, threshold: 0.5 },
    customElementRef
  );
  const [signOrSignUp, setSignOrSignUp] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const [triggerLoginModuleToggleValue, setTriggerLoginModuleToggleValue] =
    useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const TriggerLoginModuleBtnFromModule = () => {
    setTriggerLoginModuleToggleValue(false);
  };
  const TriggerLoginModuleBtn = () => {
    setTriggerLoginModuleToggleValue(true);
  };
  const chooseSignUp_SignIn = (bool) => {
    setSignOrSignUp(bool);
  };
  useEffect(() => {
    authContext.hasDiscoveryReachedBottomHandler(reachedBottom);
  }, [reachedBottom]);

  useEffect(() => {
    if (
      !authContext.isLoggedIn &&
      location.pathname.startsWith("/verifier/validate")
    ) {
      localStorage.setItem("redirectAfterLogin", location.pathname);
      navigate("/");
    }
  }, [authContext.isLoggedIn, location.pathname, navigate]);

  if (!authContext.isLoggedIn) {
    return null; // Prevents rendering protected content for logged-out users
  }

  return (
    <React.Fragment>
      <div className="fixed top-0 w-full z-10">
        <Navbar
          TriggerLoginModuleBtn={TriggerLoginModuleBtn}
          chooseSignUp_SignIn={chooseSignUp_SignIn}
        />
      </div>
      <div className="overflow-y-hidden">
        <aside
          className="hidden sm:block fixed top-[5.1rem] left-0 w-fit h-screen z-10"
          aria-label="Sidebar"
        >
          <div className="h-full overflow-y-auto">
            <Sidebar />
          </div>
        </aside>
        <div className="sm:ml-[7rem] overflow-auto ">
          {authContext.isLoggedIn && authContext.userDetails?.type && (
            <Outlet />
          )}
        </div>
        <div className="fixed sm:hidden bottom-0 w-full h-[5rem]">
          <MobileNav />
        </div>
      </div>
      <LoginModal
        TriggerBtn={triggerLoginModuleToggleValue}
        TriggerModuleBtnFromModule={TriggerLoginModuleBtnFromModule}
        signOrSignUp={signOrSignUp}
        chooseSignUp_SignIn={chooseSignUp_SignIn}
        DisplayText=""
      />
    </React.Fragment>
  );
};

export default AuthLayout;
